module.exports = __webpack_public_path__ + "img/step4.40af3c72.png";